import {
    getUnreadMessageCount,
    getMessageList,
    getMessageRead,
    sendMessage
  } from '@/axios/api/messageCenter'

  const UPDATE_UNREAD_MESSAGE_COUNT = 'UPDATE_UNREAD_MESSAGE_COUNT'
  const UPDATE_TOTAL = 'UPDATE_TOTAL'
  const UPDATE_CURRENT = 'UPDATE_CURRENT'
  const UPDATE_MESSAGE_LIST = 'UPDATE_MESSAGE_LIST'

  const state = {
    unreadMessageCount: 0,
    pager: {
		current: 1,
		size: 10,
		total: 0
	},
    messageList: [],
  }

  const getters = {
    unreadMessageCount: state => state.unreadMessageCount,
    pager: state => state.pager,
    messageList: state => state.messageList,
  }

  const mutations = {
    [UPDATE_UNREAD_MESSAGE_COUNT] (state, unreadMessageCount) {
      state.unreadMessageCount = unreadMessageCount
    },
    [UPDATE_TOTAL](state, total) {
		state.pager = { ...state.pager, total }
	},
    [UPDATE_CURRENT](state, current) {
		state.pager = { ...state.pager, current }
	},
    [UPDATE_MESSAGE_LIST] (state, messageList) {
      state.messageList = messageList.map(item => {
        const arr = item.content.match(/@#@(.+)@#@/)
        const orange = item.content.match(/<orange>(.*?)<\/orange>/g) || []
        const clickHere = arr ? arr[1] : ''
        let content = item.content.replace(
          /@#@(.+)@#@/g,
          '<span class="click-here" style="font-size: 14px; color:#007F42; text-decoration:underline;cursor:pointer">' + clickHere + '</span>'
        )
        let text = item.content.replace(/@#@(.+)@#@/g, clickHere)
        orange.forEach(v => {
          content = content.replace(v, '<span style="color:#FF6600; font-size: 14px;">' + v + '</span>')
          text = text.replace(/<orange>|<\/orange>/, '')
        })
        return {
          ...item,
          content: content,
          text: text,
          // param: item.param || {}
          param: item.param ? JSON.parse(item.param) : {}
        }
      })
    },
  }

  const actions = {
    async getUnreadMessageCountApi ({commit}, params) {
      try {
        let { data: res } = await getUnreadMessageCount(params)
        commit(UPDATE_UNREAD_MESSAGE_COUNT, res)
      } catch (e) {}
    },
    async getMessageListApi ({commit}, params) {
      try {
        let { data: res } = await getMessageList(params)
        commit(UPDATE_MESSAGE_LIST, res.records)
		commit(UPDATE_TOTAL, res.total)
      } catch (e) {}
    },
    async getMessageReadApi ({commit}, params) {
      try {
        await getMessageRead(params)
      } catch (e) {}
    },
    async sendMessageApi ({commit}, params) {
      try {
        const res = await sendMessage(params)
        return res
      } catch (e) {}
    },
  }

  export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }



// WEBPACK FOOTER //
// ./src/store/modules/messageCenter.js